<template>
  <div id="nav-component">
    <nav class="navbar navbar-expand-lg" aria-label="Header">
      <a class="navbar-brand blue nes" href="#">
        JS Hooks for Xahau
        <span class="nes-badge beta d-inline-block">
          <span class="is-error text-dark bg-warning">BETA</span>
        </span>
      </a>
    </nav>

    <div class="nav-scroller nes mb-4">
      <nav class="nav nav-underline" aria-label="Navigation">
        <a class="ps-0 pe-4 me-3 text-dark nav-link active" href="https://explorer.xahau.network/wss:jshooks.xahau-test.net" target="_blank">Explorer</a>
      </nav>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Header',
  components: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  #builder {
    background: linear-gradient(
      49deg,
      rgba(38, 17, 56, 1) 0%,
      rgba(40, 33, 46, 1) 100%
    );
    color: white;
  }
  .action-buttons {
    button {
      font-size: .65em;
    }
  }
  .nes-badge.beta {
    margin-top: 0.3em;
    margin-left: -0.8em;
    transform: scale(0.8);
    width: 6em;
    font-size: .6em;
  }
  .navbar-brand.blue {
    white-space: normal;
  }
  a.nav-link {
    .fa-2x {
      margin-top: -1em;
      position: relative;
      top: 0.1em;
      margin-right: -0.15em;
      margin-left: -0.5em;
    }
  }
  button.is-primary {
    &.alt-color {
      background-color: #183FB7;
      &:after {
        box-shadow: inset -4px -4px darken(#183FB7, 10%);
      }
      &:active:not(.is-disabled) {
        &:after {
          box-shadow: inset 4px 4px darken(#183FB7, 10%);
        }
      }
    }
  }
</style>
